module.exports = "/assets/450bdafcc7745509f37b5341e4c478bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/GR.png
// module id = 2540
// module chunks = 0